<template>
    <div class="support-widget" v-if="authenticated">
        <!-- Toggle Button - Hidden, using footer button instead -->
        <button class="widget-toggle" @click="toggleWidget" :class="{ 'has-unread': supportUnreadCount > 0 }" style="display: none !important;">
            <svg v-if="!supportWidgetOpen" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span v-if="supportUnreadCount > 0" class="widget-badge">{{ supportUnreadCount > 9 ? '9+' : supportUnreadCount }}</span>
        </button>

        <!-- Chat Window -->
        <transition name="slide-up">
            <div v-if="supportWidgetOpen" class="widget-window">
                <div class="window-header">
                    <div class="header-title">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>LIVE SUPPORT</span>
                    </div>
                    <button class="header-close-btn" @click="toggleWidget" title="Close">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div class="window-content">
                    <transition name="fade" mode="out-in">
                        <SupportTicketList v-if="supportView === 'list'" key="list" />
                        <SupportTicketCreate v-else-if="supportView === 'create'" key="create" />
                        <SupportTicketDetail v-else-if="supportView === 'detail'" key="detail" />
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SupportTicketList from '@/components/support/SupportTicketList';
import SupportTicketCreate from '@/components/support/SupportTicketCreate';
import SupportTicketDetail from '@/components/support/SupportTicketDetail';

export default {
    name: 'SupportWidget',
    components: {
        SupportTicketList,
        SupportTicketCreate,
        SupportTicketDetail
    },
    methods: {
        ...mapActions([
            'supportSetWidgetOpen',
            'supportSetView'
        ]),
        toggleWidget() {
            const newState = !this.supportWidgetOpen;
            this.supportSetWidgetOpen(newState);
            
            if(newState) {
                this.supportSetView('list');
            }
        }
    },
    computed: {
        ...mapGetters([
            'authenticated',
            'supportUnreadCount',
            'supportWidgetOpen',
            'supportView'
        ])
    }
}
</script>

<style scoped>
.support-widget {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 10000000;
    font-family: inherit;
}

.support-widget .widget-toggle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #01e1a4 0%, #00aa6d 100%);
    border: none;
    box-shadow: 0 4px 20px rgba(1, 225, 164, 0.4);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    position: relative;
    transition: all 0.3s ease;
}

.support-widget .widget-toggle:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 25px rgba(1, 225, 164, 0.6);
}

.support-widget .widget-toggle.has-unread {
    animation: pulse 2s infinite;
}

.support-widget .widget-toggle svg {
    width: 24px;
    height: 24px;
}

.support-widget .widget-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff4444;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    border-radius: 10px;
    border: 2px solid #ffffff;
}

.support-widget .widget-window {
    position: fixed;
    bottom: 100px;
    right: 20px;
    width: 380px;
    height: 600px;
    max-height: calc(100vh - 120px);
    background: var(--bg-purple-dark);
    border-radius: 15px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 10000001;
}

.support-widget .widget-window.slide-up-enter-active,
.support-widget .widget-window.slide-up-leave-active {
    transition: all 0.3s ease;
}

.support-widget .widget-window.slide-up-enter,
.support-widget .widget-window.slide-up-leave-to {
    transform: translateY(20px) scale(0.95);
    opacity: 0;
}

.support-widget .window-header {
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.support-widget .window-header .header-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 800;
    color: #ffffff;
    flex: 1;
}

.support-widget .window-header .header-title svg {
    width: 20px;
    height: 20px;
    stroke: var(--accent-yellow);
}

.support-widget .window-header .header-close-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.support-widget .window-header .header-close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
    transform: scale(1.05);
}

.support-widget .window-header .header-close-btn svg {
    width: 18px;
    height: 18px;
}

.support-widget .window-content {
    flex: 1;
    min-height: 0;
    position: relative;
    overflow: hidden;
}

@keyframes loading_animation {
    0% { transform: translateX(-100%); }
    50% { transform: translateX(100%); }
    100% { transform: translateX(100%); }
}

@keyframes pulse {
    0%, 100% { box-shadow: 0 4px 20px rgba(1, 225, 164, 0.4); }
    50% { box-shadow: 0 4px 25px rgba(1, 225, 164, 0.8), 0 0 15px rgba(1, 225, 164, 0.5); }
}

/* Mobile adjustments */
@media only screen and (max-width: 768px) {
    .support-widget .widget-window {
        width: calc(100vw - 40px);
        max-width: 380px;
        height: calc(100vh - 120px);
        bottom: 100px;
        right: 20px;
    }

    .support-widget {
        bottom: 100px;
        right: 20px;
    }
}
</style>

